// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Panel_wrapper__28Roa","title":"Panel_title__3mEe9","subPanel":"Panel_subPanel__28rpa"};